export const getSessionIsVet = () => {
  const request = sessionStorage?.getItem('is_vet')
  return request && JSON.parse(request)
}

export const saveIsVetInSession = (isVet: boolean | null) => {
  sessionStorage?.setItem('is_vet', JSON.stringify(isVet))
}
